const Subscriptions = () =>
  import("@/modules/subscriptions/pages/Subscriptions.vue");
const AddCreditCard = () =>
  import("@/modules/subscriptions/pages/AddCreditCard.vue");
const ChoosePlan = () => import("@/modules/subscriptions/pages/ChoosePlan.vue");

export default [
  {
    path: "/settings/subscriptions",
    name: "subscriptions",
    component: Subscriptions,
    children: [
      {
        path: "/settings/subscriptions/addCreditCard",
        name: "addCreditCard",
        component: AddCreditCard,
        meta: {
          authRequired: true,
        },
      },
      {
        path: "/settings/subscriptions/choosePlan",
        name: "chooseSubscriptionPlan",
        component: ChoosePlan,
        meta: {
          authRequired: true,
        },
      },
    ],
    meta: {
      authRequired: true,
    },
  },
];
